module.exports = __webpack_public_path__ + "static/img/Kiitoskortti_Avecor_jani-sinervo_A4.31f4c6f.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/salesperson-leaflets/Kiitoskortti_Avecor_jani-sinervo_A4.pdf
// module id = nqat
// module chunks = 22